import { parseIsoDate } from "@formant/date-fns/parseIsoDate";
import { IOrganization } from "@formant/core/model/IOrganization";
import { IsoDate } from "@formant/core/model/IsoDate";
import { IUser } from "@formant/core/model/IUser";

import { IOrganizationStore } from "../store/IOrganizationStore";
import { IUserStore } from "../store/IUserStore";
import pp10b from "./pp-1.0b.html";
import tos11b from "./tos-1.1b.html";
import tos12 from "./tos-1.2.html";
import tos13b from "./tos-1.3b.html";

export interface ILegalOption {
    name: string;
    date: IsoDate;
    termsDocument?: string;
    privacyPolicyDocument?: string;
    organizationOwner?: boolean;
    isCustom?: boolean;
}

const options: ILegalOption[] = [
    {
        name: "enterprise",
        date: new Date("2020/09/09").toISOString(),
        isCustom: true,
    },
    {
        name: "1.1b",
        date: new Date("2019/01/31").toISOString(),
        termsDocument: tos11b,
        privacyPolicyDocument: pp10b,
    },
    {
        name: "tos1.2_and_pp1.0b",
        date: new Date("2020/09/08").toISOString(),
        termsDocument: tos12,
        privacyPolicyDocument: pp10b,
    },
    {
        name: "tos1.3b_and_pp1.0b",
        date: new Date("2022/02/23").toISOString(),
        termsDocument: tos13b,
        privacyPolicyDocument: pp10b,
    },
    {
        name: "tos2.0_and_pp1.0b",
        date: new Date("2025/09/02").toISOString(),
        termsDocument: "https://formant.io/terms/",
        privacyPolicyDocument: "https://formant.io/privacy-policy/",
    },
];

export function currentLegal(stores: {
    userStore: IUserStore;
    organizationStore: IOrganizationStore;
}): ILegalOption | false | undefined {
    const { userStore, organizationStore } = stores;
    const user = userStore.authenticated();
    if (!user) {
        return getLatest();
    }

    const organization = organizationStore.authenticated();

    if (!organization) {
        return organization;
    }

    return findMatching(organization, user);
}

export function legalByName(name: string): ILegalOption | undefined {
    return options.find(_ => _.name === name);
}

function getLatest(): ILegalOption {
    const option = options.sort(
        (a, b) =>
            parseIsoDate(b.date).getTime() - parseIsoDate(a.date).getTime(),
    );
    return option[0];
}

function findMatching(_organization: IOrganization, user: IUser): ILegalOption {
    const option = options
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
        .find(({ organizationOwner: accountOwner }) => {
            if (
                accountOwner !== undefined &&
                accountOwner !== user.isOrganizationOwner
            ) {
                return false;
            }

            return true;
        });
    if (!option) {
        throw new Error("Cannot find TOS");
    }
    return option;
}
